export default __webpack_public_path__ + "media/images/logo/media/shibuya_no_radio-592c580a0a4bc7d2eeca967b92de44bb.jpg";